module.exports = __webpack_public_path__ + "media/images/admin/icons/pause-2550f2a2ba04229047d1d98a6aa5a8b8.svg";